

precision highp float;
precision highp sampler2D;

out vec4 fragColor;

in float speed;

void main() {
  // make particle roundshaped
  vec2 uv = vec2( gl_PointCoord.x -0.5, 1.0 - gl_PointCoord.y-0.5 );
  float dFromCenter = sqrt(uv.x*uv.x + uv.y*uv.y);
  if(dFromCenter > 0.5){
    discard;
    return;
  }

  if (speed == 0.) {
    discard;
    return;
  }

  float colorFactor = min(1.0, speed / COLOR_SPEED);

  fragColor = mix(COLOR_A, COLOR_B, colorFactor);

  float opacityFactor = smoothstep(0.05, 0.1, speed); // fade slow particles <0.1px/s change
  fragColor.a *= opacityFactor;
}
